import type { RequestConfig } from '@customTypes/index';
import type { ClubProgressDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ClubProfileProgressRequest = {
  profileId: string;
};

export type ClubProfileProgressParams =
  RequestConfig<ClubProfileProgressRequest>;

export const clubProfileProgress = async ({
  params,
  config
}: ClubProfileProgressParams) =>
  api.get<ClubProgressDto>(
    `/api/profile/progress/club/${params.profileId}`,
    config
  );
